import NProgress from 'nprogress'
let counter = 0

export default function (apiClient) {
  apiClient.interceptors.request.use(config => {
    if (counter++ === 0) {
      NProgress.start()
    }
    return config
  })

  apiClient.interceptors.response.use(response => {
    if (--counter === 0) {
      NProgress.done()
    }
    return response
  }, error => {
    if (--counter === 0) {
      NProgress.done()
    }
    return Promise.reject(error)
  })
}
